<template>
  <div>
    <loadingCube v-if="loading" :loadingMessage="loadingMsg"></loadingCube>
    <div class="timesheet-submissions" v-if="!loading">
      <div class="dates">
        <h1><i class="fas fa-calendar-alt"></i> Period: {{ getWeekStarting() }}</h1>
        <p class="mb-0">You are submitting the below timesheet instructions for period: {{ getWeekStarting() }}.
        </p>
      </div>
      <!--<div v-if="company.is_payroll" class="functionality_notes">-->
      <!--  <h3>Timesheet File Import Tool</h3>-->
      <!--  <div class="row">-->
      <!--    <div class="col-lg-8">-->
      <!--      <p class="mb-2">Use the timesheet import tool to fill out information in the Genius Portal from an uploaded file.</p>-->
      <!--    </div>-->
      <!--    <div class="col-lg-4">-->
      <!--      <button class="btn orcaBtn w-100" @click="show_upload_timesheet_file()">Upload Timesheet File</button>-->
      <!--    </div>-->
      <!--  </div>-->
      <!--  <div class="row">-->
      <!--    <div class="col-lg-8">-->
      <!--      <p class="mb-2">Use the template file if you would like to submit your timesheet via file import.</p>-->
      <!--    </div>-->
      <!--    <div class="col-lg-4 mt-1">-->
      <!--      <button v-if="templateDownloading" class="btn orcaBtn greenBtn w-100">Downloading ...</button>-->
      <!--      <button v-else class="btn orcaBtn greenBtn w-100" @click="downloadTimesheetTplFile()">Download Timesheet File</button>-->
      <!--    </div>-->
      <!--  </div>-->
      <!--</div>-->

      <sunset_timesheet_import_widget
          v-if="company.is_payroll && !isTermsAgreedTo && company_id !== null"
          prefix="x"
          :company_id="company_id"
          :end_date="this.submissionDate.end_date"
          :start_date="this.submissionDate.start_date"
      />

        <div v-if="isNotForemanRole()" class="functionality_notes" style="padding: 10px; border: 1px solid #eee; border-radius: 10px;">
            <h2>Preview Submission Totals</h2>
            <div class="row">
                <div class="col-lg-8">
                    <p class="mb-2">View a preview of totals for each site per worker for this submission period.</p>
                </div>
                <div class="col-lg-4" style="display: grid; justify-content: flex-end; align-content: center;">
                    <router-link :to="{name: 'c_timesheet_r2_submit_preview', params: {start_date: submissionDate.start_date, end_date: submissionDate.end_date}}" target="_blank">
                        <button :disabled="locationDetailsSaving" style="max-width: 250px; min-width: 250px; width: 250px;" class="btn orcaBtn">
                            <span>Preview submission totals</span>
                        </button>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="locations" v-for="(location, index) in locations">
          <location :key="index"
              :location_data="location"
              :submission_date="submission_date"
              :timesheet_cycle_id="timeSheetCycleId"
              :ms_opts="ms_opts"
              @saving-location="changeLocationSavingStatus"
              :new_ts_sites="new_ts_sites"
          >
          </location>
      </div>
      <paginator :p_pages="this.pagination.pages" :p_parent_component="this.$options.name" :p_page="this.page">
      </paginator>

      <div v-if="isNotForemanRole()" class="bulk">
        <h2>Submission certification for pay period: {{ getWeekStarting() }}</h2>
        <p>
          <label>
            <input type="checkbox" v-model="isTermsAgreedTo" />
            <span>I certify that I am an authorised member of {{ clientCompanyName }} and that the above named persons have attended
            site and should be paid for the total payments entered
            above. {{ clientCompanyName }} agrees to be bound by the Terms of Business of {{ company.name }} as previously
            received and signed.</span>
            <span v-if="company.is_payroll"> Any retention payments indicated will be released to
            the sub-contractor upon instruction by {{ clientCompanyName }}.</span>
          </label>
        </p>
        <div class="submit">
          <div class="row">
            <div class="col-12">
              <button @click="submitTimesheets" :disabled="!isTermsAgreedTo || locationDetailsSaving" class="btn orcaBtn">
                <span v-if="!locationDetailsSaving">Submit Timesheets</span>
                <span v-else>Please wait. I'm still working on time-sheets</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <timesheet_file_upload_modal v-if="$store.state.client_timesheets.show_timesheet_file_upload_modal"></timesheet_file_upload_modal>
      <timesheet_preview_file_modal v-if="$store.state.client_timesheets.show_timesheet_file_preview_modal"></timesheet_preview_file_modal>
<!--      <preview  v-if="this.isNotForemanRole()"-->
<!--        :date="submissionDate" -->
<!--        :reload_data="previewReload" -->
<!--        :ms_opts="ms_opts">-->
<!--      </preview>-->
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import paginator from 'components/pages/paginator/paginator';
import preview from '../../sunset/timesheets/client/timesheet_preview_all.vue';
import location from './timesheet_location_submitter.vue';
import timesheet_file_upload_modal from "pages/clients/timesheets/modals/select_timesheet_file_to_upload"
import timesheet_preview_file_modal from 'pages/clients/timesheets/modals/timesheet_file_upload_preview_table';
import Sunset_timesheet_import_widget from "pages/sunset/timesheets/components/shared/timesheet_import.vue";

export default {
  name: "selected_period_submit",
  props: ['company_name',
          'submission_date',
          'timesheet_template_name',
          'company_id',
          'timesheet_cycle_id'],
  components: {
    Sunset_timesheet_import_widget,
    loadingCube,
    paginator,
    preview,
    timesheet_file_upload_modal,
    timesheet_preview_file_modal,
    location
  },
  data() {
    return {
      loadingMsg: 'LOCATIONS',
      loading: false,
      new_ts_sites: null,
      templateDownloading: false,
      approved: [],
      isTermsAgreedTo: false,
      companyId: this.company_id,
      company: null,
      clientCompanyName: this.company_name,
      submissionDate: this.submission_date,
      timeSheetCycleId: this.timesheet_cycle_id,
      locations: {},
      pagination: {},
      page: 0,
      numOfResults: 10,
      locationDetailsLoading: false,
      locationDetailsSaving: false,
      locationDetails: null,
      previewReload: false,
      openLocation: false,
      isPayroll: false,
      isRecruitment: false,
      isPayrollEnabled: false,
      isRecruitmentEnabled: false,
      childLocations: [],
      ms_opts: {
        pre_add: [],
        post_add: [],
        pre_ded: [],
        post_ded: []
      },
    }
  },
  async beforeMount() {
      //Removed due to bug with server responses and blank drop downs
    // axios.get(this.crmApiPath + 'crm/attributes/ts_pre_tax_additions/company').then(response => {
    //   this.ms_opts.pre_add = response.data
    // });
    // axios.get(this.crmApiPath + 'crm/attributes/ts_post_tax_additions/company').then(response => {
    //   this.ms_opts.post_add = response.data
    // });
    // axios.get(this.crmApiPath + 'crm/attributes/ts_pre_tax_deductions/company').then(response => {
    //   this.ms_opts.pre_ded = response.data
    // });
    // axios.get(this.crmApiPath + 'crm/attributes/ts_post_tax_deductions/company').then(response => {
    //   this.ms_opts.post_ded = response.data
    // });
    this.hardCodeTypes();
    this.setFlags();
    this.loadTimesheetAuthorisations();
  },
  methods: {
    findSiteByShortName(name) {
      return this.new_ts_sites?.find(s => s.short_site_name === name) || null;
    },
    hardCodeTypes(){
      this.ms_opts.pre_add = [
          {
              "id": 107,
              "crm_attribute_master_type_id": 29,
              "value": "Bonus"
          },
          {
              "id": 112,
              "crm_attribute_master_type_id": 29,
              "value": "Fee"
          },
          {
              "id": 162,
              "crm_attribute_master_type_id": 29,
              "value": "Fuel\/Mileage"
          },
          {
              "id": 111,
              "crm_attribute_master_type_id": 29,
              "value": "Loan"
          },
          {
              "id": 170,
              "crm_attribute_master_type_id": 29,
              "value": "Miscellaneous"
          },
          {
              "id": 108,
              "crm_attribute_master_type_id": 29,
              "value": "Overtime (Bonus)"
          },
          {
              "id": 110,
              "crm_attribute_master_type_id": 29,
              "value": "Price Work"
          }
      ];
      this.ms_opts.post_add = [
          {
              "id": 114,
              "crm_attribute_master_type_id": 30,
              "value": "Clothing"
          },
          {
              "id": 116,
              "crm_attribute_master_type_id": 30,
              "value": "Fuel \/ Mileage"
          },
          {
              "id": 171,
              "crm_attribute_master_type_id": 30,
              "value": "Miscellaneous"
          },
          {
              "id": 136,
              "crm_attribute_master_type_id": 30,
              "value": "Parking"
          },
          {
              "id": 157,
              "crm_attribute_master_type_id": 30,
              "value": "Subsistence"
          },
          {
              "id": 113,
              "crm_attribute_master_type_id": 30,
              "value": "Tools\/Materials"
          }
      ];
      this.ms_opts.pre_ded = [
          {
              "id": 119,
              "crm_attribute_master_type_id": 31,
              "value": "Loan"
          },
          {
              "id": 172,
              "crm_attribute_master_type_id": 31,
              "value": "Miscellaneous"
          },
          {
              "id": 118,
              "crm_attribute_master_type_id": 31,
              "value": "Over Payment"
          },
          {
              "id": 120,
              "crm_attribute_master_type_id": 31,
              "value": "Van Hire"
          }
      ];
      this.ms_opts.post_ded = [
          {
              "id": 123,
              "crm_attribute_master_type_id": 32,
              "value": "Clothing"
          },
          {
              "id": 128,
              "crm_attribute_master_type_id": 32,
              "value": "Fines"
          },
          {
              "id": 125,
              "crm_attribute_master_type_id": 32,
              "value": "Loan"
          },
          {
              "id": 173,
              "crm_attribute_master_type_id": 32,
              "value": "Miscellaneous"
          },
          {
              "id": 129,
              "crm_attribute_master_type_id": 32,
              "value": "Parking"
          },
          {
              "id": 122,
              "crm_attribute_master_type_id": 32,
              "value": "Tools\/Materials"
          },
          {
              "id": 121,
              "crm_attribute_master_type_id": 32,
              "value": "Training"
          },
          {
              "id": 124,
              "crm_attribute_master_type_id": 32,
              "value": "Van Hire"
          }
      ];
    },
    reload(p) {
      this.page = p;
      this.loadTimesheetAuthorisations();
    },
    changeLocationSavingStatus(status) {
      this.locationDetailsSaving = status;
    },
    isNotForemanRole() {
      const me = this.$store.state.auth.me;
      return !me.roles.includes('foreman');
    },
    async fetchNewTSSites() {
      try {
        const { status, data } = await axios.get(
            `${this.crmApiPath}r2/client/timesheets/sites`,
            {
              params: { submission_date: this?.submissionDate?.end_date ?? "" },
              timeout: 15000,
              validateStatus: s => s >= 200 && s < 300
            }
        );

        if (status !== 200 || !data) {
          throw new Error(`Bad response: ${status}`);
        }

        this.new_ts_sites = Array.isArray(data.data) ? data.data : [];
        return true;
      } catch (err) {
        console.error("Could not fetch new sites:", err?.response?.status || err?.message || err);
        this.new_ts_sites = [];
        return false;
      }
    },
    async loadTimesheetAuthorisations() {
      this.loading = true;

      await this.fetchNewTSSites();

      const { data } = await axios.get(
          `${this.crmApiPath}timesheet_authorisation/client/locations/${this.$store.state.auth.me.contact_id}`,
          {
            params: {
              ts_submission_date: this?.submissionDate?.end_date ?? "",
              page_length: this.numOfResults,
              page: this.page
            }
          }
      );

      this.locations  = Array.isArray(data.data) ? data.data : [];
      this.company    = data.company ?? null;
      this.pagination = data.pagination ?? null;

      await this.prepareTimeSheetInformation();

      this.loading = false;
    },
    show_upload_timesheet_file() {
      this.$store.commit('SHOW_TIMESHEET_FILE_UPLOAD_MODAL', {
        company_id: this.company_id,
        submission_date: this.submission_date,
        timesheet_template_name: this.timesheet_template_name
      })
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'upload_timesheet_file_modal'));
    },
    import_timesheet_file(payWorkerFee) {
      this.loading = true;
      let imported_timesheets = this.$store.state.client_timesheets.timesheet_preview_info;

      axios.post(this.crmApiPath + 'timesheet/submit_timesheets_file_data', {
          payWorkerFee: payWorkerFee,
          companyID: this.companyId,
          timesheets: imported_timesheets,
      }).then(() => {
        this.loadTimesheetAuthorisations();
      });
    },
    downloadTimesheetTplFile() {
      this.templateDownloading = true;
      axios.post(this.crmApiPath + 'timesheet/download_timesheet_tpl', {
          company_id: this.company_id,
          submission_date: this.submission_date.end_date
      }, {
          responseType: 'blob'  // 👈 THIS is the missing piece
      }).then((response) => {
        this.templateDownloading = false;
        const filename = response.headers["custom-filename"];
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
    prepareTimeSheetInformation() {
      this.sortTimesheetAuthorisations();
      this.loading = false;
    },
    sortTimesheetAuthorisations() {
      let self = this;
      // Sort the timesheet authorisations into alphabetical order of the selectted location name
      this.locations = this.locations.sort(function (a, b) {
        a = self.getLocationName(a).toLowerCase();
        b = self.getLocationName(b).toLowerCase();

        return (a < b) ? -1 : (a > b) ? 1 : 0;
      });
    },
    setChildLocationRefs(el) {
      if (el) {
        this.childLocations.push(el);
      }
    },
    checkInvoice() {
      return false;
      let state = false;
      this.childLocations.forEach(ref => {
        if(ref.invoiceAmountCheck) {
            state = true;
        }
      });

      return state;
    },
    submitTimesheets() {
      this.loadingMsg = '';

      axios.get(this.crmApiPath + 'timesheet_authorisation/client/locations/can-submit/' + this.$store.state.auth.me.contact_id, {
        params: {
          ts_submission_date: this.submissionDate.end_date
        }
      }).then(response => {
        if(response.data.status === 'success') {

          if(this.checkInvoice()) {
            this.submitError('There are locations with timesheets that are populated but not saved or approved. <br>Please save/approve them before submit.');
            return;
          }

          this.loading = true;
          this.submitApi();
        } else {

          let error = response.data.message + '<br><br>';

          response.data.data.forEach(function(msg) {
              error += msg + '<br>';
          });

          this.loading = false;
          this.submitError(error);
        }
      });
    },
    submitError(msg, type = 'Warning') {

      // unapproved timesheets found
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">' + type + '</div>' +
          '<div class="snotifyToast__body">' + msg +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'OK', action: (toast) => {
              this.$snotify.remove(toast.id);
            }
          }
        ]
      });


    },
    submitApi() {
      axios.post(this.crmApiPath + 'timesheet/submit_timesheets', {
          ts_submission_date: this.submissionDate.end_date,
          company_id: this.companyId,
          date_start: this.submissionDate.start_date,
          date_end: this.submissionDate.end_date,
          contact_id: this.$store.state.auth.me.contact_id,
          contact_email: this.$store.state.auth.me.email,
          contact_name: this.$store.state.auth.me.first_name,
          company_name: this.companyName,
          is_payroll_enabled: this.isPayrollEnabled
      }).then(response => {
        if(response.data.status === 'success') {
          window.location.reload();
          return;
        }

        this.submitError(response.data.message);
      });
    },
    setFlags() {
      this.isPayroll = (this.crmType === 'payroll')
      this.isRecruitment = (this.crmType === 'recruitment');
      this.isPayrollEnabled = (this.isPayroll || this.isRecruitment && !this.$store.state.auth.me.recruitment);
      this.isRecruitmentEnabled = (this.isRecruitment && this.$store.state.auth.me.recruitment)
    },
    getWeekStarting() {
      let start = this.$options.filters.formatDate(this.submissionDate.start_date);
      let end = this.$options.filters.formatDate(this.submissionDate.end_date);

      return start + ' - ' + end;
    },
    getLocationName(location) {
      if(location.alt_address_name) {
        return location.alt_address_name;
      }

      return location.job_address_full;
    }
  },
  directives: {
  }
}
</script>

<style lang="scss">
.selected_row td,
.selected_row th {
  background-color: lighten($bc_1, 5%) !important;
}
</style>
